import moment, { Moment } from 'moment'

export const disableReportDate = (current: Moment | null): boolean => {
  if (!current) {
    return false
  }

  const today = moment().endOf('day')
  const oneYearAgo = moment().subtract(1, 'year').startOf('day')

  return current.isBefore(oneYearAgo) || current.isAfter(today)
}
